import { useState } from "react";
import { ConsumptionPeriod } from "../../types";

function useConsumptionPeriod() {
  return useState<ConsumptionPeriod>(ConsumptionPeriod.Week);
}

export default useConsumptionPeriod;
